import React from 'react'
import { useSelector } from 'react-redux'
import { Navigate } from 'react-router-dom';

const Protected = ({ children }) => {

    const isAuthenticated = useSelector((state) => state.admin.isAuthenticated)

    if (!isAuthenticated) {
        return <Navigate to="/auth/sign-in" replace />;
    }

    return children;
}

export default Protected